import { IConfigsType } from '../../types'

const fwWingstopCorporateGuestConfig: IConfigsType = {
  'fw_wingstop-corporate-base-zj8m1ewp': {
    '/:brand/corporate_guest': {
      variables: ['corporateGroup'],
      groupFilter: {
        api: 'corporateFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'trailing_7_days',
          'custom',
        ],
      },
      title: {
        type: 'title',
        title: 'Systemwide Guest',
      },
      smgBreakdownByStoreTitle: {
        type: 'title',
        title: 'SMG BREAKDOWN BY STORE',
      },
      smgBreakdownByStoreDownloadCsv: {
        type: 'download-csv',
        api: 'fwWingstopSmgBreakdownByStore',
        fileName: '<%- "getexpo-smg-" + startDate + "-" + endDate %>',
        message: 'Download Table as CSV',
        fields: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns.slice(0, 1)) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
          },
          {
            key: 'cpkScore',
            title: 'CPK',
          },
          {
            key: 'digitalCount',
            title: 'Digital OSAT - Count',
          },
          {
            key: 'digitalPercent',
            title: 'Digital OSAT - Score',
          },
          {
            key: 'deliveryCount',
            title: 'Delivery OSAT - Count',
          },
          {
            key: 'deliveryPercent',
            title: 'Delivery OSAT - Score',
          },
          {
            key: 'nonDigitalCount',
            title: 'Non-Digital OSAT - Count',
          },
          {
            key: 'nonDigitalPercent',
            title: 'Non-Digital OSAT - Score',
          },
          {
            key: 'dissatisfactionCount',
            title: 'Dissatisfaction - Count',
          },
          {
            key: 'dissatisfactionPercent',
            title: 'Dissatisfaction - Score',
          },
          {
            key: 'inaccurateCount',
            title: 'What Went Wrong - Accurate - Count',
          },
          {
            key: 'inaccuratePercent',
            title: 'What Went Wrong - Accurate - Score',
          },
          {
            key: 'qscCount',
            title: 'QSC Score - Count',
          },
          {
            key: 'qscScore',
            title: 'QSC Score - Score',
          },
          {
            key: 'wingyouCount',
            title: 'WingYou Completion - Count',
          },
          {
            key: 'wingyouScore',
            title: 'WingYou Completion - Score',
          },
        ],
      },
      smgBreakdownByStore: {
        type: 'table-v2',
        api: 'fwWingstopSmgBreakdownByStore',
        pagination: {
          pageSize: 20,
        },
        row: {
          pinning: {
            top: ['-2', '-1', '0'],
          },
        },
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns.slice(0, 1)) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            width: '350px',
            sortable: true,
          },
          {
            key: 'cpkScore',
            title: 'CPK',
            width: '80px',
            align: 'center',
            sortable: true,
            decimal: 2,
          },
          {
            key: 'Digital OSAT',
            title: 'Digital OSAT',
            align: 'center',
            children: [
              {
                key: 'digitalCount',
                width: '80px',
                title: 'Count',
                align: 'center',
                sortable: true,
              },
              {
                key: 'digitalPercent',
                width: '80px',
                title: 'Score',
                align: 'center',
                sortable: true,
                decimal: 0,
              },
            ],
          },
          {
            key: 'Delivery OSAT',
            title: 'Delivery OSAT',
            align: 'center',
            children: [
              {
                key: 'deliveryCount',
                width: '80px',
                title: 'Count',
                align: 'center',
                sortable: true,
              },
              {
                key: 'deliveryPercent',
                width: '80px',
                title: 'Score',
                align: 'center',
                sortable: true,
                decimal: 0,
              },
            ],
          },
          {
            key: 'Non-Digital OSAT',
            title: 'Non-Digital OSAT',
            align: 'center',
            children: [
              {
                key: 'nonDigitalCount',
                width: '80px',
                title: 'Count',
                align: 'center',
                sortable: true,
              },
              {
                key: 'nonDigitalPercent',
                width: '80px',
                title: 'Score',
                align: 'center',
                sortable: true,
                decimal: 0,
              },
            ],
          },
          {
            key: 'Dissatisfaction',
            title: 'Dissatisfaction',
            align: 'center',
            children: [
              {
                key: 'dissatisfactionCount',
                width: '80px',
                title: 'Count',
                align: 'center',
                sortable: true,
              },
              {
                key: 'dissatisfactionPercent',
                width: '80px',
                title: 'Score',
                align: 'center',
                sortable: true,
                decimal: 0,
              },
            ],
          },
          {
            key: 'What Went Wrong - Accurate',
            title: 'What Went Wrong - Accurate',
            align: 'center',
            children: [
              {
                key: 'inaccurateCount',
                width: '80px',
                title: 'Count',
                align: 'center',
                sortable: true,
              },
              {
                key: 'inaccuratePercent',
                width: '80px',
                title: 'Score',
                align: 'center',
                sortable: true,
                decimal: 0,
              },
            ],
          },
          {
            key: 'QSC Score',
            title: 'QSC Score',
            align: 'center',
            children: [
              {
                key: 'qscCount',
                width: '80px',
                title: 'Count',
                align: 'center',
                sortable: true,
              },
              {
                key: 'qscScore',
                width: '80px',
                title: 'Score',
                align: 'center',
                sortable: true,
                decimal: 2,
              },
            ],
          },
          {
            key: 'WingYou Completion',
            title: 'WingYou Completion',
            align: 'center',
            children: [
              {
                key: 'wingyouCount',
                width: '80px',
                title: 'Count',
                align: 'center',
                sortable: true,
              },
              {
                key: 'wingyouScore',
                width: '80px',
                title: 'Score',
                decimal: 2,
                align: 'center',
                sortable: true,
              },
            ],
          },
        ],
      },
    },
  },
}

export default fwWingstopCorporateGuestConfig
